(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/poy-ranking-list/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/poy-ranking-list/assets/javascripts/utils.js');
"use strict";

const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  log = _svs$core.log;
const logger = log.getLogger('module:poker_react:components:poy_ranking_list');
const rankingYear = svs.poker_react.data.poyCurrentRankingConfig.year;
const svsFetch = svs.core.svsFetch.create();
const QuarterFilters = [{
  label: 'Kvartal 1',
  value: '01'
}, {
  label: 'Kvartal 2',
  value: '04'
}, {
  label: 'Kvartal 3',
  value: '07'
}, {
  label: 'Kvartal 4',
  value: '10'
}];
const Tags = [{
  label: 'POY-Ranking',
  value: 'POY',
  ariaLabel: 'Player of the year ranking'
}, {
  label: 'Mini-Ranking',
  value: 'MINI'
}];
const normalizePlayers = playerList => playerList.map(player => ({
  value: player.points,
  name: player.nickname,
  rankingPos: player.rankingPos
}));
const fetchRankingsFromCloud = async params => {
  const response = await svsFetch("/v1/ranking/ranking-list?".concat(params.toString()), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error("Error fetching poker ranking from cloud: ".concat(response.status, " ").concat(response.statusText));
  }
  const result = await response.json();
  return {
    lastUpdated: result.lastUpdated || null,
    players: normalizePlayers(result.players || []),
    isNameSearch: result.isNameSearch || false,
    totalPlayerCount: result.totalPlayerCount || 0,
    error: null
  };
};
const fetchRankingsFromJupiter = async params => {
  const _await$jupiter$callAs = await jupiter.callAsync({
      method: 'GET',
      path: "/poker/1/ranking?".concat(params.toString())
    }),
    response = _await$jupiter$callAs.response;
  if (!(response !== null && response !== void 0 && response.result)) {
    throw new Error("Error fetching poker ranking from Jupiter: invalid response");
  }
  return {
    lastUpdated: response.result.lastUpdated || null,
    players: normalizePlayers(response.result.players || []),
    isNameSearch: response.result.isNameSearch || false,
    totalPlayerCount: response.result.totalPlayerCount || 0,
    error: null
  };
};
const fetchRankings = async _ref => {
  let period = _ref.period,
    searchString = _ref.searchString,
    tag = _ref.tag;
  try {
    const params = new URLSearchParams();
    const rankingPeriod = period === 'year' ? period : 'quarter';
    params.append('period', rankingPeriod);
    if (searchString !== null && searchString !== void 0 && searchString.length) {
      params.append('qs', searchString);
    }
    params.append('tag', tag);
    const rankingMonth = period === 'year' ? '01' : period;
    const dateString = dateFns.format(new Date("".concat(rankingYear, "-").concat(rankingMonth, "-01 00:00")), 'yyyy-MM-dd HH:mm');
    params.append('time', dateString);
    if (svs.core.detect.feature('ft-poker-use-new-ranking-api-cloud')) {
      return await fetchRankingsFromCloud(params);
    }
    return await fetchRankingsFromJupiter(params);
  } catch (error) {
    logger.error("Error fetching poker ranking: ".concat(error));
    return {
      lastUpdated: null,
      players: [],
      isNameSearch: false,
      totalPlayerCount: 0,
      error
    };
  }
};
const getPeriodFilters = () => {

  const startOfYear = dateFns.startOfYear(new Date(rankingYear));
  const endOfYear = dateFns.endOfYear(new Date(rankingYear));
  let clampedCurrentDate = new Date();
  if (dateFns.isBefore(clampedCurrentDate, startOfYear)) {
    clampedCurrentDate = startOfYear;
  } else if (dateFns.isAfter(clampedCurrentDate, endOfYear)) {
    clampedCurrentDate = endOfYear;
  }
  return [{
    label: 'År',
    value: 'year'
  }, ...QuarterFilters.slice(0, dateFns.getQuarter(clampedCurrentDate))];
};
setGlobal('svs.poker_react.components.poyRankingList.common', {
  fetchRankings,
  normalizePlayers,
  Periods: getPeriodFilters(),
  Tags
});

 })(window);